module.exports = __webpack_public_path__ + "assets/images/icons/icon_x-grey.svg?v=14a2452f";